import React from 'react';

const LOCAL_RASTER = /^\/(team|logos|videos)\/[^?#]+\.(jpe?g|png)$/i;

export const toWebp = (src) =>
  typeof src === 'string' && LOCAL_RASTER.test(src) ? src.replace(/\.(jpe?g|png)$/i, '.webp') : src;

// Serves the WebP sibling of local JPG/PNG assets, falling back to the original on error.
export default function Img({ src, decoding = 'async', onError, ...rest }) {
  const webp = toWebp(src);
  const handleError = (e) => {
    if (webp !== src && !e.currentTarget.dataset.fallback) {
      e.currentTarget.dataset.fallback = '1';
      e.currentTarget.src = src;
    }
    if (onError) onError(e);
  };
  return <img src={webp} decoding={decoding} onError={handleError} {...rest} />;
}
